import React from 'react';
import { useIntl } from 'react-intl';
import { Box } from '@ipc/ipc-components';
import ErrorLayout from './ErrorLayout';
import { frontEndUrl, httpOnlySecurityService } from '../../../externals/iam';
import Button from '../../common/Button';

const RefreshTokenError = () => {
  const intl = useIntl();
  const goLoginPage = () => {
    window.location.href = frontEndUrl;
  };

  setTimeout(() => goLoginPage(), 10000);
  httpOnlySecurityService.clear();

  return (
    <ErrorLayout
      title={intl.formatMessage({
        id: 'app.errorBoundary.refreshTokenError.title',
      })}
    >
      <p>
        {intl.formatMessage({ id: 'app.errorBoundary.refreshTokenError.subtitle' })}
        &nbsp;
      </p>
      <p> if you are not redirected to the login page after 10 seconds click this button.</p>
      <Box padding="20px">
        <Button type="button" onClick={goLoginPage}>
          Login Page
        </Button>
      </Box>
    </ErrorLayout>
  );
};

export default RefreshTokenError;
